import { render } from "./LoginWindowAbout.vue?vue&type=template&id=3d201d96&scoped=true"
import script from "./LoginWindowAbout.vue?vue&type=script&lang=js"
export * from "./LoginWindowAbout.vue?vue&type=script&lang=js"

import "./LoginWindowAbout.vue?vue&type=style&index=0&id=3d201d96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d201d96"]])

export default __exports__